import { gql } from '@apollo/client';

export const GET_CURRENT_USER = gql`
  query GET_CURRENT_USER {
    me {
      id
      email
      userConfirmed
      confirmationToken
      verified
      stripeId
      stripeAccountStatus
      userType
      avatar {
        fileUrl
      }
      isOnboarded
      isBlocked
      profile {
        id
        name
        firstName
        lastName
        bio
        website
        collaborationStatus
        country
        city
      }

      desiredCollaborationProfession {
        value: id
        label: name
      }

      skills {
        id
        name
      }

      professions {
        id
        name
      }
      userInterests
      coffeeChatFrequency
      coffeeChatAvailability
      coffeeChatAutoIcebreaker
      coffeeChatPreferences
    }
  }
`;
